<template>
  <div class="mobile-header">

    <router-link
        class="messages"
        :to="{name: 'pages.messages'}"
    >
      <img v-if="boImage" :src="boImage" alt="Image Bo de Wit">
    </router-link>
  </div>
</template>

<script>
import bo from "../../assets/images/bo-messages.png";

export default {
  name: "MobileHeader",
  data() {
    return {
      boImage: bo,
      messageAvailable: false,
    };
  },
};
</script>
